// Since `raf` package doesn't provide an ES6 export, it had to be copy-posted here and changed to ES6.
// https://gitlab.com/catamphetamine/virtual-scroller/-/issues/40
// Source: https://github.com/chrisdickinson/raf/blob/master/index.js
var root = typeof window === 'undefined' ? global : window;
var vendors = ['moz', 'webkit'];
var suffix = 'AnimationFrame';
var raf = root['request' + suffix];
var caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for (var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
} // Some versions of FF have rAF but not cAF


if (!raf || !caf) {
  var last = 0;
  var id = 0;
  var queue = [];
  var frameDuration = 1000 / 60;

  raf = function raf(callback) {
    if (queue.length === 0) {
      var _now = Date.now();

      var next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function () {
        var cp = queue.slice(0); // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue

        queue.length = 0;

        for (var _i = 0; _i < cp.length; _i++) {
          if (!cp[_i].cancelled) {
            try {
              cp[_i].callback(last);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }

    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id;
  };

  caf = function caf(handle) {
    for (var _i2 = 0; _i2 < queue.length; _i2++) {
      if (queue[_i2].handle === handle) {
        queue[_i2].cancelled = true;
      }
    }
  };
}

export function request(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn);
}
export function cancel() {
  caf.apply(root, arguments);
} // export function polyfill(object) {
//   if (!object) {
//     object = root;
//   }
//   object.requestAnimationFrame = raf
//   object.cancelAnimationFrame = caf
// }
//# sourceMappingURL=polyfill.js.map